// Shared free-tier gate copy (expansion date window, signal blur, API keys).
export default {
  premium: {
    tag: "PRO",
    gate: {
      signalsTitle: "सबसे नए {n} सिग्नल लॉक हैं",
      signalsDesc:
        "अपग्रेड करें और हर कंपनी के पहले दिन से सभी विस्तार सिग्नल देखें।",
      signalsCta: "सिग्नल अनलॉक करें",
    },
    dateWindow: {
      tip: "फ़्री प्लान पिछले {n} दिन कवर करता है। पूरा इतिहास देखने के लिए अपग्रेड करें।",
      lockedLabel: "पूरा इतिहास देखने के लिए अपग्रेड करें",
    },
    apiKeys: {
      bannerTitle: "API एक्सेस एक सशुल्क सुविधा है",
      bannerDesc:
        "कुंजियाँ बनाएँ, एक्सपोर्ट स्वचालित करें, और Pubrio को प्रोग्रामैटिक रूप से क्वेरी करें।",
      tip: "API कुंजी बनाने के लिए अपना प्लान अपग्रेड करें।",
      cta: "प्लान देखें",
    },
    team: {
      locked: "टीम देखें",
      tip: "इस बाज़ार में मौजूद स्थानीय टीम देखने के लिए अपग्रेड करें।",
    },
    source: {
      locked: "स्रोत देखें",
      tip: "हर सिग्नल के स्रोत तक पहुँचने के लिए अपग्रेड करें।",
    },
    employees: {
      locked: "कर्मचारी डेटा लॉक है",
      tip: "इस कंपनी की संख्या और लोगों को देखने के लिए अपग्रेड करें।",
      cta: "कर्मचारी अनलॉक करें",
    },
    markets: {
      moreLocked: "+{n} और बाज़ार",
    },
  },
};
